import Grid from "@mui/material/Grid";
import { CBCreationOfProps, CBOmissionType, IFormValues } from "../../types";
import { useRecoilValue } from "recoil";
import { isGlobalEditModeState, sapEnumState } from "../../state/customerbaseState";
import FormController from "../formController/FormController";
import { Controller, useFormContext } from "react-hook-form";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

interface CBConsentProps extends CBCreationOfProps {
    index: number
}

const CBConsent = ({
    index,
    creationOf
}: CBConsentProps) => {

    const { t } = useTranslation('customerbase');

    //const isCreationMode = !!creationOf;

    const formContext = useFormContext<IFormValues>();

    //const editing = useRecoilValue(isGlobalEditModeState);
    const sapEnum = useRecoilValue(sapEnumState);

    return (
        <Grid container columnSpacing={3} rowSpacing={1}>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbConsents.${index}.companyCode`}
                    idField={`consent-company-code-${index}`}
                    label="companyCode"
                    options={sapEnum.companyCodes || []}
                    showSelect={false /*isCreationMode || editing*/}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbConsents.${index}.division`}
                    idField={`consent-division-${index}`}
                    label="division"
                    options={sapEnum.divisions || []}
                    showSelect={false /*isCreationMode || editing*/}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbConsents.${index}.communicationChannel`}
                    idField={`consent-communication-channel-${index}`}
                    label="communicationChannel"
                    options={sapEnum.communicationChannels || []}
                    showSelect={false /*isCreationMode || editing*/}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbConsents.${index}.distributionChannel`}
                    idField={`consent-distribution-channel-${index}`}
                    label="distributionChannel"
                    options={sapEnum.distributionChannels || []}
                    showSelect={false /*isCreationMode || editing*/}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbConsents.${index}.revocationChannel`}
                    idField={`consent-revocation-channel-${index}`}
                    label="revocationChannel"
                    options={sapEnum.revocationChannels || []}
                    showSelect={false /*isCreationMode || editing*/}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbConsents.${index}.revocationReason`}
                    idField={`consent-revocation-reason-${index}`}
                    label="revocationReason"
                    options={sapEnum.revocationReasons || []}
                    showSelect={false /*isCreationMode || editing*/}
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <Controller
                    control={formContext.control}
                    name={`cbConsents.${index}.acquisitionDateTime`}
                    render={({field, fieldState}) =>
                        <DateTimePicker 
                            readOnly={true /*isCreationMode ? false : !editing*/}
                            label={t("acquisitionDateTime")}
                            value={field.value.includes(CBOmissionType.OMISSION_DASH) ? null : field.value}
                            onChange={(value)=>{
                                field.onChange(dayjs(value).format("YYYY-MM-DDTHH:mm:ssZ"));
                            }}
                            inputFormat={"DD-MM-YYYY HH:mm"}
                            ampm={false}
                            renderInput={(params: any) => (
                                <TextField
                                    id={`consent-acquisitionDateTime-${index}`}
                                    variant="standard"
                                    fullWidth
                                    label={t("acquisitionDateTime")}
                                    {...params}
                                    error={Boolean(fieldState.error)}
                                    helperText={fieldState.error?.message}
                                />
                            )} 
                        />
                    }
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <Controller
                    control={formContext.control}
                    name={`cbConsents.${index}.revocationDateTime`}
                    render={({field, fieldState}) =>
                        <DatePicker 
                            readOnly={true /*isCreationMode ? false : !editing*/}
                            label={t("revocationDate")}
                            value={field.value == CBOmissionType.OMISSION_DASH ? null : (field.value || null)}
                            onChange={(value)=>{
                                field.onChange(dayjs(value).format("YYYY-MM-DD"));
                            }}
                            inputFormat={"DD-MM-YYYY"}
                            renderInput={(params: any) => (
                                <TextField
                                    id={`consent-revocationDate-${index}`}
                                    variant="standard"
                                    fullWidth
                                    label={t("revocationDate")}
                                    {...params}
                                    error={Boolean(fieldState.error)}
                                    helperText={fieldState.error?.message}
                                />
                            )} 
                        />
                    }
                />
            </Grid>
            <Grid item md={6} xs={12}>
                <FormController 
                    formName={`cbConsents.${index}.termCondType`}
                    idField={`consent-termCond-type-${index}`}
                    label="termCondType"
                    options={sapEnum.consentTypes || []}
                    showSelect={false /*isCreationMode || editing*/}
                />
            </Grid>
        </Grid>
    )

}

export default CBConsent;